import { useQuery } from '@tanstack/react-query';
import { websiteBannerControllerGetShopifySetupDeeplink } from '@/generated/korza-api-client';
import { useTenant } from '@/hooks/use-tenant';

export function useShopifySetupDeeplink() {
  const tenant = useTenant();

  return useQuery({
    queryKey: ['website-banner', 'shopify-setup-deeplink', tenant.id],
    queryFn: async (): Promise<string> => {
      const res = await websiteBannerControllerGetShopifySetupDeeplink({
        query: { tenantId: tenant.id },
      });
      if (res.data == null) throw new Error('No setup deeplink');
      if (typeof res.data.setupDeeplink !== 'string') {
        throw new Error('No setup deeplink');
      }
      return res.data.setupDeeplink;
    },
    enabled: Boolean(tenant.id),
  });
}
